export default __webpack_public_path__ + "static/media/be.e0476389.svg";